@let smallScreen = smallScreen$ | async;
@let mediumScreen = mediumScreen$ | async;
@let selectedLanguage = selectedLanguage$ | async;
@let isPlaying = isPlaying$ | async;
@let isLoading = isLoading$ | async;
<!-- @let largeScreen = largeScreen$ | async; -->

@let playerWidth = (smallScreen ? '100%' : mediumScreen ? '600px' : '800px');

<div class="video-player" #demoPlayer [ngStyle]="{'--player-width': playerWidth }" (click)="isPlaying ? pause() : null">
    @if(!isPlaying){
    <div class="overlay">

        @if(isLoading) {
        <ng-lottie class="loader" [options]="{ path: '/assets/animations/svet-loader.json'}" width="30" />
        } @else {
        <lucide-angular name="play" (click)="play()" />
        }

    </div>
    }

    <video #videoPlayer [controls]="false" class="videoPlayer" controls>
        <source type="video/mp4">
        {{'player.tag_error' | translate}}
    </video>
</div>

<ul id="sound-list" #soundList [ngStyle]="{'--player-width': playerWidth }">
    <li magicHover [ngClass]="{'selected': soundsEnabled}" (click)="toggleSounds()"><lucide-angular
            name="audio-waveform" /></li>
    @if (languages) {
    @for (audioEl of audiosElements; track $index) {
    <li magicHover [ngClass]="{'selected': audioEl.language.id === selectedLanguage?.id}" class="sound-item"
        (click)="onLanguageChange(audioEl.language)">
        {{ audioEl.language.name }}
    </li>
    }
    }
    <li magicHover class="option" (click)="interval ? clearInterval() : initInterval()"
        [ngClass]="{'selected': interval}"><lucide-angular [color]="interval ? '#EFF9F5' : '#919A96'"
            name="hourglass" /></li>
    <!-- <li magicHover class="option" [ngClass]="{'selected': interval}"><lucide-angular color="#919A96" name="plus" /></li> -->
</ul>